import { useContext } from 'react';
import { MainAreaRightShiftContext } from '../components/Chat.SidePanel/context';

/**
 * For a floating pane that uses `position: fixed` and a static `right` inset (e.g. a
 * "Find" or "Edit Speakers" popover anchored to the corner of its screen), a hardcoded
 * `right: 10px` is measured against the viewport. That breaks once the chat side panel
 * can open alongside the page: the pane keeps hugging the viewport edge and ends up
 * rendered on top of the panel instead of the content next to it.
 *
 * `MainArea` (see Chat.SidePanel/Layout.tsx) measures how far its own right edge has
 * shifted from the viewport's right edge — 0 unless the side panel is actually open and
 * shrinking it — and provides that via context. This hook just reads it; it doesn't
 * know or duplicate what a pane's own base gutter is. Add it on top of that gutter in
 * the pane's stylesheet, e.g. via a CSS custom property:
 * `right: calc(10px + var(--tool-pane-shift, 0px))`.
 */
export const useToolPaneAnchor = () => useContext(MainAreaRightShiftContext);
